import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {Site} from '../../shared/models/site';
import {LoadSiteMultiOneSubscriptionSuccessAction, LoadSiteSuccessAction, siteActionTypes} from '../actions/site-load';
import {PatchSitesSuccessAction, siteUpdateActionTypes} from '../actions/subscription-site-update';
import {LoadSubscriptionSuccessAction, subscriptionActionTypes} from '../actions/subscription-load';
import {SubscriptionI} from '../../shared/models/subscription-i';

export interface SiteState {
  site: Site;
}

const initialState: SiteState = {
  site: undefined
};

export function SiteReducer(state: SiteState = initialState, action: Action): SiteState {
  switch (action.type) {
    case siteActionTypes.LOAD_SUCCESS:
    case siteActionTypes.LOAD_SUCCESS_MULTI:
    case siteActionTypes.LOAD_SUCCESS_MULTI_ONE_SUBSCRIPTION:
      return handleLoadSuccessAction(state, action);
    case subscriptionActionTypes.LOAD_SUCCESS:
      return handleLoadSubscriptionSuccessAction(state, action);
    case siteActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case siteActionTypes.CLEAR:
      return handleLoadClearActions();
    // case siteUpdateActionTypes.PATCH_SUCCESS:
    //   return handleUpdateSubscription(state, action);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: SiteState, action: LoadSiteSuccessAction): SiteState {
  const newState: SiteState = {
    site: action.payload
  };
  return newState;
}
// function handleLoadMultiOneSubSuccessAction(state: SiteState, action: LoadSiteMultiOneSubscriptionSuccessAction): SiteState {
//   const newState: SiteState = {
//     site: action.payload
//   };
//   // newState = _.cloneDeep(newState);
//   // if (newState.site.subscriptions.length > 0 ) {
//   //   newState.site.subscriptions.push(newState.site.subscriptions[0])
//   //   newState.site.subscriptions[0] = null;
//   // }
//
//   return newState;
// }

function handleLoadClearActions(): SiteState {
  return initialState
}

function handleLoadErrorActions(state: SiteState): SiteState {
  return state;
}
function handleLoadSubscriptionSuccessAction(state: SiteState, action: LoadSubscriptionSuccessAction): SiteState {
  const newState = _.cloneDeep(state);
  if (newState.site) {
    if (!newState.site.subscriptions) {
      newState.site.subscriptions = [];
      newState.site.subscriptions.push(action.payload);
    } else {
      for (let i = 0; i < newState.site.subscriptions.length; i++) {
       if (newState.site.subscriptions[i].uuid === action.payload.uuid) {
         const tmp = newState.site.subscriptions[0];
         newState.site.subscriptions[0] = action.payload;
         newState.site.subscriptions[i] = tmp;
       }
      }
    }
  }

  return newState;
}

function handleUpdateSubscription(state: SiteState, action: PatchSitesSuccessAction): SiteState {
  const path = action.payload.path;
  const response = action.payload.response;
  // tslint:disable-next-line:no-any
  let siteTemp: any;

  switch (path) {
    case 'site': {
      siteTemp = ({
        site: {
          ...state.site,
          ...{
            displayName: response.displayName,
            name: response.displayName,
            externalID: response.externalID,
            timeZone: response.timeZone,
            cultures: response.cultures
          }
        }
      });
      break;
    }
    case 'subscription': {
      return {
        site: {
          ...state.site,
          ...{
            subscriptions: state.site.subscriptions.map(subscription => {
              let first = true;
              if (first) {
                first = false;
                return {
                  ...subscription, ...{
                    product: response.product,
                    status: response.status,
                  }
                }
              } else {
                return subscription;
              }
            })
          }
        }
      };
    }
    case 'serverForm': {
      let first = true;
      siteTemp = {
        site: {
          ...state.site,
          ...{
            subscriptions: state.site.subscriptions.map(subscription => {
              if (first) {
                first = false;
                return { ...subscription, ...{ server: response } }
              } else {
                return subscription;
              }
            })
          }
        }
      };
      break;
    }
    case 'videoOption': {
      let first = true;
      siteTemp = {
        site: {
          ...state.site,
          ...{
            subscriptions: state.site.subscriptions.map(subscription => {
              if (first) {
                first = false;
                return { ...subscription, ...{ screenRotation: response.screenRotation } }
              } else {
                return subscription;
              }
            })
          }
        }
      };
      break;
    }
    case 'commentsForm': {
      let first = true;
      siteTemp = {
        site: {
          ...state.site,
          ...{
            subscriptions: state.site.subscriptions.map(subscription => {
              if (first) {
                first = false;
                return { ...subscription, ...{ comments: response.comments } }
              } else {
                return subscription;
              }
            })
          }
        }
      };
      break;
    }
    case 'ipAddress': {
      let first = true;
      siteTemp = {
        site: {
          ...state.site,
          ...{
            subscriptions: state.site.subscriptions.map(subscription => {
              if (first) {
                first = false;
                return ({
                  ...subscription,
                  network: {
                    ...subscription.network, ipAddress: response
                  }
                })
              } else {
                return subscription;
              }
            })
          }
        }
      };
      break;
    }
    case 'proxy': {
      let first = true;
      siteTemp = {
        site: {
          ...state.site,
          ...{
            subscriptions: state.site.subscriptions.map(subscription => {
              if (first) {
                first = false;
                return ({
                  ...subscription,
                  network: {
                    ...subscription.network, proxy: response
                  }
                })
              } else {
                return subscription;
              }
            })
          }
        }
      };
      break;
    }
    case 'wifi': {
      let first = true;
      siteTemp = {
        site: {
          ...state.site,
          ...{
            subscriptions: state.site.subscriptions.map(subscription => {
              if (first) {
                first = false;
                return ({
                  ...subscription,
                  network: {
                    ...subscription.network, wifi: response
                  }
                })
              } else {
                return subscription;
              }
            })
          }
        }
      };
      break;
    }
    case 'address': {
      siteTemp = {
        site: {
          ...state.site,
          ...{
            addresses: state.site.addresses.map(address => {
              if (address.id === response.id) {
                return {
                  ...address,
                  ...{
                    addressType: response.addressType,
                    line1: response.line1,
                    line2: response.line2,
                    line3: response.line3,
                    zip: response.zip,
                    city: response.city,
                    state: response.state,
                    country: response.country,
                  }
                }
              } else {
                return address;
              }
            })
          }
        }
      };
      break;
    }
    case 'contact': {
      siteTemp = {
        site: {
          ...state.site,
          ...{
            contacts: state.site.contacts.map(contact => {
              if (contact.contact.id === response.id) {
                return {
                  type: contact.type,
                  contact: {
                    uuid: contact.contact.uuid,
                    id: contact.contact.id,
                    name: response.name,
                    surname: response.surname,
                    culture: contact.contact.culture,
                    email: response.email,
                    phone: response.phone,
                    mobile: response.mobile,
                    skype: contact.contact.skype,
                    address: contact.contact.address,
                    department:  response.department,
                    sex: contact.contact.sex,
                    typeUser: contact.contact.typeUser,
                    comments: contact.contact.comments,
                    groupRole: contact.contact.groupRole,
                    created: contact.contact.created,
                    updated: contact.contact.updated,
                    updatedBy: contact.contact.updatedBy,
                    createdBy: contact.contact.createdBy,
                    fax: contact.contact.fax
                  }
                }
              } else {
                return contact;
              }
            })
          }
        }
      };
      break;
    }
    default: {
      siteTemp = state;
    }
  }
  siteTemp = handleUpdatedBy(state, siteTemp, response);
  return siteTemp;
}

// tslint:disable-next-line:no-any
function handleUpdatedBy(state: SiteState, siteTemp: any, response: any): any {
  return ({
    site: {
      ...siteTemp.site,
      ...{
        updatedBy: response.updatedBy,
        updated: response.updated
      }
    }
  });
}

export const siteSelectors = {
  site: (state: SiteState) => _.get(state, 'site', null),
  subscription: (state: SiteState) => _.get(state, 'site.subscriptions[0]', null),
  productsBySite: (site, products) => {
    const playersIds = [];
    if (site.site && site.site.subscriptions[0]) {
      site.site.subscriptions[0].players.forEach(player => playersIds.push(player.productID));
      return products.array.filter(product => playersIds.includes(product.id));
    }
    return null;
  },
  productsByService: (site, products) => {
    // console.log(products , site.site.subscriptions)
    return products.array.filter(product => {
      if (site.site && site.site.subscriptions[0]) {
        return product[site.site.subscriptions[0].service.name.toLowerCase()] === true;
      }
      return null;
    });
  }
};


